<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-location`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 2a1 1 0 011 1v3.11c8.343.922 14.968 7.547 15.89 15.89H45a1 1 0 011 1v2a1 1 0 01-1 1l-3.11.001c-.923 8.343-7.547 14.967-15.89 15.89V45a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.11C13.658 40.968 7.033 34.343 6.11 26H3a1 1 0 01-1-1v-2a1 1 0 011-1h3.11C7.032 13.658 13.657 7.033 22 6.11V3a1 1 0 011-1h2zm1 8.142V13a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2.858c-6.13.877-10.98 5.727-11.858 11.858H13a1 1 0 011 1v2a1 1 0 01-1 1h-2.858c.877 6.132 5.727 10.981 11.858 11.858V35a1 1 0 011-1h2a1 1 0 011 1v2.858c6.132-.877 10.98-5.727 11.858-11.857L35 26a1 1 0 01-1-1v-2a1 1 0 011-1h2.858c-.877-6.13-5.726-10.98-11.857-11.858zM26 26v-4h-4v4h4z"/></svg>
</template>
<script>

export default {
  name: 'IconLocation',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
